module.exports = __webpack_public_path__ + "bd43be8d408e4ed05a3cfc89e0f9e988.png";